import type { ProductFlag } from '@/products/shared/utils/feature-access';

/** All products that support per-user UI access overrides. */
export type UserProductAccessKey = ProductFlag;

export const USER_PRODUCT_ACCESS_OPTIONS: ReadonlyArray<{
  key: UserProductAccessKey;
  label: string;
}> = [
  { key: 'email-analytics', label: 'Email Analytics' },
  { key: 'email-analytics-v2', label: 'Lumen' },
  { key: 'penny', label: 'Penny' },
  { key: 'new-payroll-testing', label: 'Payroll Testing' },
  { key: 'penny2', label: 'Penny 2' },
  { key: 'chat', label: 'Chat Engine' },
  { key: 'compliance', label: 'Compliance' },
  { key: 'integrations', label: 'Integrations' },
] as const;

/**
 * Resolve whether a user may access a product in the UI.
 * Missing override (null/undefined) inherits tenant enablement — treat as allowed.
 */
export const isUserProductAccessAllowed = (
  enabledOverride: boolean | null | undefined,
): boolean => {
  if (enabledOverride === null || enabledOverride === undefined) {
    return true;
  }
  return enabledOverride;
};

export const USER_PRODUCT_ACCESS_TABLE = 'user_product_access' as const;
